import {
  getData,
  postData,
  patchData,
  deleteData
} from './Services';

// ═══════════════════════════════════════════════════════════════════════════
// CLIENTES - ZONAS (Relación)
// ═══════════════════════════════════════════════════════════════════════════

export const getClientesZonasPanel = async (zona_id, searchTerm, page, perPage) => {
  let queryParams = [];
  if (zona_id) {
    queryParams.push(`zona_id=${encodeURIComponent(zona_id)}`);
  }
  if (searchTerm) {
    queryParams.push(`search=${encodeURIComponent(searchTerm)}`);
  }
  if (page) {
    queryParams.push(`page=${encodeURIComponent(page)}`);
  }
  if (perPage) {
    queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
  }
  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await getData("/clientesZonas", queryString);
};

export const getClienteZonaById = async (id) => {
  return await getData(`/clientesZonas/${id}`);
};

export const getZonaPrincipalCliente = async (user_id) => {
  return await getData(`/clientesZonas/zona-principal/${user_id}`);
};

export const calcularCostoEnvio = async (user_id, subtotal) => {
  return await getData(`/clientesZonas/calcular-envio/${user_id}?subtotal=${subtotal}`);
};

export const asignarZonasPorGps = async (user_id, latitud, longitud) => {
  return await postData('/clientesZonas/asignar-por-gps', { user_id, latitud, longitud });
};

export const postClienteZona = async (body) => {
  return await postData('/clientesZonas', body);
};

export const patchClienteZona = async (id, body) => {
  return await patchData(`/clientesZonas/${id}`, body);
};

export const deleteClienteZona = async (id) => {
  return await deleteData(`/clientesZonas/${id}`);
};
